import React from 'react';
import {FieldOutputProps} from '../field/DetailsFieldValue';
import {SpacerWidget} from '../widgets/SpacerWidget';

type Props = FieldOutputProps;

export const SpacerField: React.FC<Props> = (props) => {
  return <SpacerWidget />;
};
